import { MOCK_SCORE_CONFIG } from 'src/apps/dashboard/constants/BusinessUnitsTable';
import { IScoreData } from 'src/apps/dashboard/types/BusinessUnitsTableTypes';

export const generateMockScore = (unitId: string, baseScore: number): IScoreData => {
	const seed = unitId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
	const variation =
		(seed % MOCK_SCORE_CONFIG.SCORE_VARIATION_RANGE) - MOCK_SCORE_CONFIG.SCORE_VARIATION_RANGE / 2;
	const score = Math.max(
		MOCK_SCORE_CONFIG.MIN_SCORE,
		Math.min(MOCK_SCORE_CONFIG.MAX_SCORE, baseScore + variation)
	);
	const percentage =
		(seed % MOCK_SCORE_CONFIG.PERCENTAGE_VARIATION_RANGE) -
		MOCK_SCORE_CONFIG.PERCENTAGE_VARIATION_RANGE / 2;

	return {
		value: score,
		percentage
	};
};
